import axios from "axios";
const CONTROLLER_PATH = "Broker";
class BrokerService {
    //CREATE
    create(formData) {
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }

    addNote(brokerId, text) {
        return axios.put(CONTROLLER_PATH + "/" + brokerId + "/addNote", { text: text }).then((response) => response.data);
    }

    //READ
    get(id, urlParameters, requestId) {
        return axios
            .get(CONTROLLER_PATH + (id ? "/" + id : ""), {
                params: urlParameters,
                requestId: requestId,
            })
            .then((response) => ({
                data: response.data,
                requestId: response.config.requestId,
            }));
    }
    getlist() {
        return axios.get(CONTROLLER_PATH + "/getlist").then((response) => response.data);
    }

    comissionReport(fromDate, toDate) {
        var urlParameters = {
            fromDate: fromDate,
            toDate: toDate,
        };
        return axios
            .get(CONTROLLER_PATH + "/ComissionReport", {
                params: urlParameters,
            })
            .then((response) => {
                return response.data;
            });
    }

    //UPDATE
    update(id, formData) {
        //formData.append('_method', 'PUT');
        return axios
            .put(CONTROLLER_PATH + "/" + id, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + "/" + id).then(() => {});
    }
}

export default new BrokerService();
